import "./InputMultilineDirective.scss";

import type { IAttributes, IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputMultilineDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public require = "ngModel";

    public scope = {
        irHelpBlock: "<",
        irLabel: "<",
        ngModel: "=",
    };

    public template: string;

    public compile = InputDirectiveFunctions.compile(this.link); // eslint-disable-line @typescript-eslint/unbound-method

    constructor(private readonly $timeout: any) {
        this.template = `
            <div class="input-multiline">
                <textarea rows="1"
                          class="form-control"
                          aa-field-group="ngModel"
                          aa-label="{{irLabel | translate}}"></textarea>
                <span ng-if="irHelpBlock" class="help-block">{{ irHelpBlock | translate}}</span>
            </div>`;
    }

    public link(
        scope: any,
        instanceElement: JQuery,
        instanceAttributes: IAttributes,
        ngModelController: any,
        transclude?: any,
    ) {
        InputDirectiveFunctions.link(scope, instanceElement, instanceAttributes, ngModelController, transclude);

        const $textarea = instanceElement.find("textarea");
        const textarea = $textarea[0];

        $textarea.on("input propertychange", () => this.resizeToFitContent(textarea as any));

        this.$timeout(() => this.resizeToFitContent(textarea as any));
    }

    public resizeToFitContent(textarea: HTMLTextAreaElement) {
        const { value, placeholder: placeholderText } = textarea;

        if (!value) {
            return;
        }

        textarea.style.height = "auto";
        textarea.style.overflow = "hidden";
        textarea.placeholder = "";

        textarea.style.height = `${textarea.scrollHeight}px`;
        textarea.style.overflow = "";
        textarea.placeholder = placeholderText;
    }
}

module("mmGui").directive("irInputMultiline", ["$timeout", ($timeout: any) => new InputMultilineDirective($timeout)]);
